import { PlusIcon } from '@heroicons/react/outline';
import Link from 'next/link';

export default function RedirectButton({ href, title }) {
  return (
    <Link
      href={href}
      className="group my-auto flex rounded-md bg-transparent font-semibold text-teal-700 hover:text-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
    >
      <span>{title}</span>

      <PlusIcon className="my-auto ml-1 h-4 w-4 group-hover:rotate-90 group-hover:duration-700"></PlusIcon>
    </Link>
  );
}
